import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { Logout } from "@mui/icons-material";
import { useAuth } from "../../contexts/AuthContext";

export default function LogoutButton({
  showIcon = true,
  showText = false,
  variant,
  sx = {},
}) {
  const { signOut } = useAuth();

  if (showIcon && !showText) {
    return (
      <Box component="div">
        <IconButton sx={{ color: "#FFFFFF", ...sx }} onClick={signOut}>
          <Logout />
        </IconButton>
      </Box>
    );
  }

  return (
    <Button
      onClick={signOut}
      startIcon={showIcon ? <Logout /> : null}
      variant={variant || 'outlined'}
      color='error'
      sx={{
        ...sx,
      }}
    >
      {showText ? "Logout" : null}
    </Button>
  );
}
